import { SparklesIcon } from 'assets/icons';
import ScrollableTableWrapper from 'components/table/components/ScrollableTableWrapper';
import TableSkeleton from 'components/table/components/TableSkeleton';
import Thead from 'components/table/components/thead';
import Tooltips from 'components/tooltips/Tooltips';
import useText from 'hooks/useText';
import CompanyTableRow from './CompanyTableRow';

// The columns after « Entreprise », by tab.
const COLUMNS = {
  prospects: ['columnDepartment', 'columnCategory', 'columnGroup', 'columnAction', 'columnCreated', 'columnCommercial'],
  new: ['columnDepartment', 'columnCategory', 'columnGroup', 'columnAction', 'columnCommercial'],
  old: ['columnDepartment', 'columnCategory', 'columnGroup', 'columnAction', 'columnRecruiter', 'columnCommercial'],
  lost: ['columnDepartment', 'columnCategory', 'columnReason', 'columnRelaunch', 'columnLostOn', 'columnCommercial'],
};

/**
 * The companies of a tab in the admin's table (ScrollableTableWrapper, Thead,
 * TableRow); without `companies`, grey rows while they are read. The reason
 * a company was lost is the AI's summary of the exchanges.
 */
const CompanyTable = ({ tab, companies, busy, selectedId, team, meId, onOpen, onOpenGroup, onAssign }) => {
  const { text } = useText('companies');
  const header = [
    text('columnCompany'),
    ...COLUMNS[tab].map((key) =>
      key === 'columnReason' ? (
        <span className="flex items-center gap-1.5">
          {text(key).toUpperCase()}
          <Tooltips text={text('reasonTooltip')} placement="top">
            <span className="flex text-gray-500">
              <SparklesIcon wh={14} color="currentColor" />
            </span>
          </Tooltips>
        </span>
      ) : key === 'columnCommercial' ? (
        // The commercial's avatar speaks for itself: no title over it.
        ''
      ) : (
        text(key)
      ),
    ),
  ];
  return (
    <ScrollableTableWrapper>
      <table className={`w-full table-auto text-gray-500 ft-sm transition-opacity ${busy ? 'opacity-60' : ''}`}>
        <thead className="sticky top-0 z-10">
          <Thead champsHeader={header} pathname="/companies" />
        </thead>
        {companies ? (
          <tbody>
            {companies.map((company, index) => (
              <CompanyTableRow
                key={company._id}
                company={company}
                tab={tab}
                index={index}
                selectedId={selectedId}
                team={team}
                meId={meId}
                onOpen={onOpen}
                onOpenGroup={onOpenGroup}
                onAssign={onAssign}
              />
            ))}
          </tbody>
        ) : (
          // Thead adds an empty column for the actions.
          <TableSkeleton columns={header.length + 1} label={text('loading')} />
        )}
      </table>
    </ScrollableTableWrapper>
  );
};

export default CompanyTable;
